import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconClarifyLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 16.75h5a.725.725 0 0 0 .534-.215.725.725 0 0 0 .216-.535.725.725 0 0 0-.216-.534.725.725 0 0 0-.534-.216H7a.725.725 0 0 0-.535.216.725.725 0 0 0-.215.534.73.73 0 0 0 .215.535.725.725 0 0 0 .535.215Zm10-9.5a.725.725 0 0 0-.535.215.725.725 0 0 0-.215.535v8a.73.73 0 0 0 .215.535.725.725 0 0 0 .535.215.725.725 0 0 0 .535-.215.725.725 0 0 0 .215-.535V8a.725.725 0 0 0-.215-.535A.725.725 0 0 0 17 7.25Zm-10 5.5h5a.725.725 0 0 0 .534-.216.725.725 0 0 0 .216-.534.725.725 0 0 0-.216-.534.725.725 0 0 0-.534-.216H7a.725.725 0 0 0-.535.216.725.725 0 0 0-.215.534c0 .213.072.391.215.534A.725.725 0 0 0 7 12.75Zm0-4h5a.725.725 0 0 0 .534-.216A.725.725 0 0 0 12.75 8a.725.725 0 0 0-.216-.535A.725.725 0 0 0 12 7.25H7a.725.725 0 0 0-.535.215A.725.725 0 0 0 6.25 8c0 .213.072.391.215.534A.725.725 0 0 0 7 8.75ZM4.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h15.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v13.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H4.308Zm0-1.5h15.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V5.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H4.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconClarifyLine;
